module.exports = __webpack_public_path__ + "img/hero-vid-poster_cn.c02d202.jpg";